// extracted by mini-css-extract-plugin
module.exports = {"w12kxl7t":"w12kxl7t","bjhwkgt":"bjhwkgt"};